/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Settings_Danger_DescriptionInputs */



/**
* | output |
* | --- |
* | "Permanently delete this project and all its data." |
*
* @param {Project_Settings_Danger_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_settings_danger_description = /** @type {((inputs?: Project_Settings_Danger_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Settings_Danger_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Projekt und alle zugehörigen Daten unwiderruflich löschen.")
	return /** @type {LocalizedString} */ ("Permanently delete this project and all its data.")
});